// required props to use Dropdown component:
// handleOnChange - onChange event handler that updates React.js state
// name - the state key that is being updated (represented by a string)
// value - the state value that is selected by default (represented by a string)
// options - array of options. Either plain strings (value === label), or
// { value, label } objects when the submitted value differs from the text
// e.g. ["AK", "AL", ...] or [{ value: 'AL', label: 'Alabama' }, ...]
//
// optional props:
// placeholder - label for a leading empty-valued option. Pass this whenever
// `value` can be '', otherwise the browser silently selects (and displays)
// the first real option while React state stays empty -- so re-picking that
// first option fires no change event and its value can never be submitted.

import React, { Component } from 'react';

class Dropdown extends Component {
  renderOptions() {
    const options = this.props.options.map((option, i) => {
      const value = option?.value ?? option;
      const label = option?.label ?? option;

      return (
        <option value={value} key={`${this.props.name}-${i}`}>
          {label}
        </option>
      );
    });

    return options;
  }

  render() {
    const className = this.props.className ? this.props.className : '';
    const { placeholder } = this.props;

    return (
      <select
        className={className}
        onChange={this.props.handleOnChange}
        value={this.props.value}
        name={this.props.name}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {this.renderOptions()}
      </select>
    );
  }
}

export default Dropdown;
